import { createContext, type PropsWithChildren, useContext, useEffect, useState } from 'react'

import { EnrollmentClientContextType } from '../types/fields/enrollments/enrollment'

type EnrollmentContextType = {
  enrollment: EnrollmentClientContextType
  setEnrollment: (enrollment: EnrollmentClientContextType) => void
}

export const EnrollmentContext = createContext<EnrollmentContextType | undefined>(undefined)

type EnrollmentProviderProps = {
  enrollment: EnrollmentClientContextType
}

const EnrollmentProvider = ({
  children,
  enrollment
}: PropsWithChildren<EnrollmentProviderProps>) => {
  const [state, setState] = useState<EnrollmentClientContextType>(enrollment)

  useEffect(() => {
    setState(enrollment)
  }, [enrollment])

  return (
    <EnrollmentContext.Provider value={{ enrollment: state, setEnrollment: setState }}>
      {children}
    </EnrollmentContext.Provider>
  )
}

export const useEnrollmentContext = () => {
  const context = useContext(EnrollmentContext)
  if (!context) throw new Error('useEnrollmentContext must be used within an EnrollmentProvider')
  return context
}

export default EnrollmentProvider
